<template>
  <div class="order-wrapper">
    <div class="order_success order_success_o order-result">
      <div style="text-align: center;margin-bottom: 20px;">
        <div class="order-result-msg">
          <div class="one">
            <span>订单信息</span>
          </div>
        </div>
      </div>
    </div>
    <div class="order-result-bottom">
      <div class="order-result-route-info">
        <div>
          <div class="one overflow-ellipsis-line1">
            <span>产品名称：</span>
            <em>{{res.planInfo.route_plan_name}}</em>
          </div>
          <div class="tow">
            <span>订单编号：</span>
            <em>{{res.orderInfo.order_info_id}}</em>
          </div>
          <a
            @click="$pushByName('customerOrderDetail',{order_id: orderId})"
            href="javascript:void(0);"
          >
            <em>查看订单详情</em>
            <img alt src="~@/assets/images/html/blue_arrow_07.png">
          </a>
        </div>
        <div>
          <div class="one">
            <span>出行日期：</span>
            <em>{{$dateUtil.df(res.orderInfo.depart_time)}}</em>
          </div>
          <div class="tow">
            <span>订单金额：</span>
            <i>{{res.orderInfo.total_amount | currency}}</i>
          </div>
        </div>
        <amount-detail
          :advanceList="res.advanceList"
          :favorableList="res.favorableList"
          :orderAdditionalCosts="res.orderAdditionalCosts"
          :orderInfo="res.orderInfo"
          :orderNums="res.orderNums"
          :ticketPrices="res.ticketPrices"
          :ticketType="res.ticketTypes"
        ></amount-detail>
      </div>
      <div class="order-result-hint">
        <span>温馨提示：请尽快完成支付，超时订单可能会被取消。</span>
      </div>
      <div class="order-result-pay">
        <div class="order-pay-button">
          <a @click="payWeixin()" href="javascript:void(0);">
            <span>微信支付</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { amountDetail } from '../agent/components/'
export default {
  name: "PayOrder",
  componentName: "PayOrder",
  components: {
    amountDetail
  },
  data () {
    return {
      res: {
        orderInfo: {},
        planInfo: {},
        // deposit: null,
        advanceList: [],
        favorableList: [],
        orderAdditionalCosts: [],
        orderNums: [],
        ticketTypes: [],
        ticketPrices: [],
        paidAmount: 0
      },

      orderId: '',
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
    }
  },
  created () {
    this.orderId = this.$route.query.order_id
    if (this.orderId == undefined) {
      this.$msg('订单号异常', 'error')
      return
    }

    this.$myGet('order_info/details/' + this.orderId, { modules: 'plan,structure,additional,ticket,amount' }) //deposit
      .then(res => {
        this.$util.copy(res.response.data, this.res);
        console.log(this);
      })
      .catch(err => {
        console.log('err:' + err)
      })
  },
  methods: {
    payWeixin () {
      //iOS在jsAPI支付时，地址还是刚从公众号时进入时的地址(对单页应用程序)，需要强制刷新页面。否则会出现“当前页面URL未注册”的错误
      this.$util.href('pay/payWeixin?order_id=' + this.orderId, this.$router);
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/pay/payOrder.vue